// Die vier Aufgaben einer Runde: Icon-Name (components/icons/Icon.jsx),
// kurzer Name fuer die Ueberschrift und der Akkusativ fuer Saetze
// ("Wer den Titel zuerst weiss").
export const AUFGABEN = {
  TITLE: { icon: "titel", name: "Titel", akkusativ: "den Titel" },
  ARTIST: { icon: "interpret", name: "Interpret", akkusativ: "den Interpreten" },
  YEAR: { icon: "jahr", name: "Jahr", akkusativ: "das Jahr" },
  ALBUM: { icon: "album", name: "Album", akkusativ: "das Album" },
};
